import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import AccountMenu from '@components/account-menu';
import Content from '@components/content';
import LiveChatWidgetWrapper from '@components/live-chat-widget-wrapper';
import LAYOUT from '@constants/layout';
import { useResponsive } from '@hooks/use-responsive';
import '@ciceksepeti/cs-theme/base.scss';
import style from './styles.module.scss';
var Section = function (props) {
    var _a;
    var layout = props.layout, isLiveChatWidgetSticky = props.isLiveChatWidgetSticky;
    var _b = useResponsive(), isMobileDevice = _b.isMobileDevice, isTabletMobile = _b.isTabletMobile;
    var hasLeftColumn = layout === LAYOUT.SIDEBARLEFT;
    var wrapperCn = classNames(style.wrapper, (_a = {},
        _a[style.wrapperTabletMobile] = isTabletMobile,
        _a));
    var containerCn = classNames(style.containerFlex, {
        container: !isMobileDevice,
        containerMobile: isMobileDevice
    });
    return (_jsx("section", { className: wrapperCn, children: layout === LAYOUT.FULLWIDTH_LITE_HEADER_NO_FOOTER ? (_jsx(Content, {})) : (_jsxs("div", { className: containerCn, children: [hasLeftColumn ? _jsx(AccountMenu, {}) : null, isMobileDevice && !isTabletMobile && (_jsx(LiveChatWidgetWrapper, { isSticky: isLiveChatWidgetSticky })), _jsx(Content, {})] })) }));
};
export default Section;
